import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { discountBasedUserDetails, getDiscountLogsType } from "../../components/discounts/shared/viewDiscountModule";

export interface discountHistoryProps { offset: number, limit: number }

interface commonType {
    loading: boolean,
    error: string
}

interface IntialValueProps {
    loading: boolean,
    error: string | null,
    userDetailsRes: commonType & { value: discountBasedUserDetails | null },
    discountLogRes: commonType & { value: getDiscountLogsType | null }
}

const initialState: IntialValueProps = {
    loading: true,
    error: null,
    userDetailsRes: { value: null, loading: true, error: "" },
    discountLogRes: { value: null, loading: true, error: "" }
}

export const getDiscountBasedUserDetails = createAsyncThunk('viewDiscount/getDiscountBasedUserDetails', ({ storeId, id }: { storeId: number, id: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getDiscountBasedUserDetails, { storeId: storeId, discountId: id })
    return HttpRoutingService?.getMethod<discountBasedUserDetails>(url)
})

export const getPosDiscountHistoryLogs = createAsyncThunk("viewDiscount/getPosDiscountHistoryLogs", ({ storeId, id, data }: { storeId: number, id: number, data: discountHistoryProps }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getPosDiscountHistoryLogs, { storeId: storeId, discountId: id })
    return HttpRoutingService?.getMethod<getDiscountLogsType>(url, data)
})

export const ViewDiscountSlice = createSlice({
    name: "viewDiscount",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDiscountBasedUserDetails?.pending, (state) => {
                state.userDetailsRes.loading = true
            })
            .addCase(getDiscountBasedUserDetails?.fulfilled, (state, action) => {
                state.userDetailsRes.loading = false
                state.userDetailsRes.value = action?.payload
            })
            .addCase(getDiscountBasedUserDetails?.rejected, (state, action) => {
                state.userDetailsRes.loading = false
                state.userDetailsRes.error = action?.error?.message as string
            })
            .addCase(getPosDiscountHistoryLogs?.pending, (state) => {
                state.discountLogRes.loading = true
            })
            .addCase(getPosDiscountHistoryLogs?.fulfilled, (state, action) => {
                state.discountLogRes.loading = false
                state.discountLogRes.value = action?.payload
            })
            .addCase(getPosDiscountHistoryLogs?.rejected, (state, action) => {
                state.discountLogRes.loading = false
                state.discountLogRes.error = action?.error?.message as string
            })
    }
})

export default ViewDiscountSlice?.reducer